import { useEffect, useRef } from 'react';
import { AiFillWarning } from 'react-icons/ai';

import config from '@/config';

import './styles/FormError.scss';

// TODO: IMPROVEMENT: RENAME EVERYTHING AND THIS SHOULD ALSO BE READY FOR PROGRAMATICALLY PAINT ERRORS IN SCREEN WITHOUT NEEDING TO HAVE A CERTAIN DOM ELEMENT (JUST A KEY THAT IDENTIFIES THE ERROR AND TO CHECK IF ERROR MATCHES THAT KEY)

export default function FormError({ error, element, focus=false, errorClassName="", alternativeElement=null }) {
  const errorContainer = useRef();
  const errorMessage = useRef();

  useEffect(()=>{
    const targetId = alternativeElement || element;
    const elementCandidates = [element, alternativeElement].filter(Boolean);
    const targetElement = targetId ? document.getElementById(targetId) : null;
    const candidateElements = elementCandidates
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    const isEmptyFieldError = error?.error_code === "EMPTY_FIELD";

    if(error?.element === element) { /** This means that this component has to be the one to handle the error */
      candidateElements.forEach((candidate) => {
        if (errorClassName) candidate.classList.remove(errorClassName);
        candidate.classList.remove("missing-field-error");
      });

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth"
        });

        if(errorClassName) targetElement.classList.add(errorClassName);
        if (isEmptyFieldError) {
          targetElement.classList.add("missing-field-error");
        }
      }

      if(error?.error_code && !isEmptyFieldError) {
        errorContainer.current.classList.add("active");
        errorMessage.current.innerText = config.errorCodes[error.error_code];
      } else {
        errorContainer.current.classList.remove("active");
      }

      if(focus === true && targetElement) targetElement.focus();
    } else {
      candidateElements.forEach((candidate) => {
        if (errorClassName) candidate.classList.remove(errorClassName);
        candidate.classList.remove("missing-field-error");
      });
      errorContainer.current.classList.remove("active");
    }
  }, [error, alternativeElement, element, errorClassName, focus]);

  return (
    <>
      <div className="form-error__message-container" ref={errorContainer}>
        <AiFillWarning className="form-error__message-icon"/>
        <p className="form-error__message-text" ref={errorMessage}></p>
      </div>
    </>
  );
}
